import { Link } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import MemberHeader from "@/components/MemberHeader";
import { SupportChat } from "@/components/SupportChat";
import { ArrowLeft } from "lucide-react";

export default function SupportPage() {
  const { user } = useAuth();
  return (
    <div className="min-h-screen sc-paper">
      <MemberHeader />
      <main data-testid="support-page" className="max-w-3xl mx-auto px-4 sm:px-8 py-10">
        <Link to="/area" className="inline-flex items-center gap-2 sc-label text-[#6E5F58] hover:text-[#48020C]"><ArrowLeft className="w-4 h-4" /> Voltar</Link>
        <div className="sc-label text-[#48020C] mt-6">Apoio</div>
        <h1 className="font-serif text-4xl sm:text-5xl text-[#26130E] mt-2">Falar com o admin</h1>
        <p className="text-[#6E5F58] mt-3 max-w-lg">Tens uma dúvida ou algum problema? Escreve-nos diretamente — é um canal privado entre ti e a organização do Club. Respondemos por aqui.</p>
        <div className="mt-8">
          {user?.id && <SupportChat threadId={`support:${user.id}`} subtitle="Conversa privada com a organização" heightClass="h-[60vh]" />}
        </div>
      </main>
    </div>
  );
}
